import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { PriceTypeToken } from '@sleed/bizcommerce-api';
import { priceTypesApi } from '~/lib/api/client';
import { formToToken, type PriceTypeFormValues } from '~/lib/schemas/price-type';

export const priceTypeKeys = {
	all: ['price-types'] as const,
	list: () => [...priceTypeKeys.all, 'list'] as const
};

export function usePriceTypesList() {
	return useQuery<PriceTypeToken[]>({
		queryKey: priceTypeKeys.list(),
		queryFn: async () => (await priceTypesApi.getAll()).data.items ?? []
	});
}

export function usePriceTypeMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: priceTypeKeys.list() });
	const create = useMutation({
		mutationFn: async (form: PriceTypeFormValues) => (await priceTypesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: PriceTypeFormValues) => (await priceTypesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await priceTypesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
